import { toTitleCase } from '../../../../../_metronic/helpers';
import { BadgeColor } from '../../../../modules/components/badge/types';
import { FieldStatus, SiRequestAssigneeStatus, SiRequestStatus } from '../../mappings';

export const getImagePathByFilename = (filename: string) =>
  filename && `${process.env.REACT_APP_SITE_INTELLIGENCE_IMG_BASE_URL}captures${filename}`;

export const getImagePathByCaptureId = (
  captureId: string,
  screenshots?: any[]
) => {
  if (!captureId) return null;

  const matchedCapture = screenshots?.find((item) => item?.capture_id === captureId);
  if (matchedCapture?.file_path) {
    return getImagePathByFilename(matchedCapture.file_path);
  }
  return null;
};

export const getActiveItemsOnly = (items: any[], keyToExtract: string) => {
  return (
    items
      ?.filter((item) => item.field_status === FieldStatus.ACTIVE)
      ?.map((item) => item[keyToExtract]) ?? []
  );
};

export const parseSiRequestStatus = (status: string) => {
  let color: BadgeColor = 'muted';
  let label: string = toTitleCase(status.replaceAll('_', ' '));
  switch (status) {
    case SiRequestStatus.PENDING:
    case SiRequestStatus.PROCESSING:
    case SiRequestStatus.SCANNED:
    case SiRequestStatus.APPROVING:
    case SiRequestStatus.REVIEWING:
      color = 'warning';
      label = 'Pending';
      break;
    case SiRequestStatus.REVIEWED:
    case SiRequestStatus.AUTO_DONE:
    case SiRequestStatus.FINISHED:
      color = 'success';
      label = 'Reviewed';
      break;
    case SiRequestStatus.FAILED:
      color = 'danger';
      break;
    default:
      break;
  }
  return { label, color };
};

export type SiRequestUser = {
  email: string;
  user_id: string;
};

export type FieldUpdate = {
  path: string;
  updated_by: string;
  updated_at: string;
  version: number;
};

export const getFieldUpdate = (
  path: string,
  fieldUpdates?: ReadonlyArray<FieldUpdate> | null
): FieldUpdate[] => {
  if (!path || !fieldUpdates?.length) {
    return [];
  }

  return fieldUpdates
    .filter((update) => update.path === path)
    .sort((a, b) => {
      if (a.version !== b.version) {
        return b.version - a.version;
      }

      return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
    });
};

export const urlToFile = async (url: string) => {
  if (!url) return null;

  try {
    const response = await fetch(url);

    // Check if the HTTP status code is in the 200-299 range
    if (!response.ok) {
      return null;
    }

    const blob = await response.blob();
    const fileName = url.split('/').pop() || 'file';

    return new File([blob], fileName, { type: blob.type });
  } catch (error) {
    // Handle network errors (e.g., DNS failure, cross-origin CORS blocking, etc.)
    return null;
  }
};

export const getTranslatedValueWithFallback = (translation: { key: string, value: string | string[], language: 'sc' | 'en' | 'tc' }[], language: 'sc' | 'en' | 'tc', key: string, fallbackValue: any) => {
  return translation?.find((item) => item.language === language && item.key === key)?.value || fallbackValue;
};
